/* ============================================
   NEW BRANDS CAROUSEL FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const brandsCarousels = document.querySelectorAll('.brands-carousel');
    if (brandsCarousels.length === 0) return;

    // Initialize each brands carousel
    brandsCarousels.forEach((brandsCarousel) => {
        const carousel = brandsCarousel.querySelector('.brands-carousel__carousel');
        const track = brandsCarousel.querySelector('.brands-carousel__track');
        const items = brandsCarousel.querySelectorAll('.brands-carousel__item');
        const prevButton = brandsCarousel.querySelector('.brands-carousel__arrow--prev');
        const nextButton = brandsCarousel.querySelector('.brands-carousel__arrow--next');
        const progressBar = brandsCarousel.querySelector('.brands-carousel__progress-bar');
        const progressLine = brandsCarousel.querySelector('.brands-carousel__progress-line');

        if (!carousel || !track || items.length === 0) return;

        initCarousel(brandsCarousel, carousel, track, items, prevButton, nextButton, progressBar, progressLine);
    });

    function initCarousel(brandsCarousel, carousel, track, items, prevButton, nextButton, progressBar, progressLine) {
        let currentIndex = 0;
        let itemsPerView = 2; // Mobile: 2 items
        let totalSlides = 0;
        let maxIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;

        function equalizeBrandCardHeights() {
            const cards = brandsCarousel.querySelectorAll('.brands-carousel__item');
            let maxHeight = 0;

            cards.forEach((card) => {
                if (!(card instanceof HTMLElement)) return;
                card.style.minHeight = '';
            });

            cards.forEach((card) => {
                if (!(card instanceof HTMLElement)) return;
                const h = card.getBoundingClientRect().height;
                if (h > maxHeight) maxHeight = h;
            });

            cards.forEach((card) => {
                if (!(card instanceof HTMLElement)) return;
                card.style.minHeight = `${Math.ceil(maxHeight)}px`;
            });
        }

        function getTrackGap() {
            const computedStyles = window.getComputedStyle(track);
            const gap = parseFloat(computedStyles.columnGap || computedStyles.gap || '0');
            return Number.isNaN(gap) ? 0 : gap;
        }

        function updateItemWidths() {
            const carouselWidth = carousel.offsetWidth;
            if (!carouselWidth) return;

            const gap = getTrackGap();
            const itemWidth = (carouselWidth - (gap * (itemsPerView - 1))) / itemsPerView;
            const safeItemWidth = itemWidth > 0 ? itemWidth : carouselWidth / itemsPerView;

            items.forEach((item) => {
                item.style.flexBasis = `${safeItemWidth}px`;
                item.style.maxWidth = `${safeItemWidth}px`;
                item.style.width = `${safeItemWidth}px`;
            });
        }

        // Update items per view based on screen size
        function updateItemsPerView() {
            const desktopCardsRaw = brandsCarousel.getAttribute('data-cards-desktop');
            const desktopCards = Number.parseInt(desktopCardsRaw || '3', 10);
            const desktopPerView = [2, 3, 4, 5].includes(desktopCards) ? desktopCards : 3;
            if (window.innerWidth >= 992) {
                itemsPerView = desktopPerView; // Desktop configurable
            } else {
                itemsPerView = 2; // Mobile/Tablet: 2 items
            }

            const totalItems = items.length;
            totalSlides = Math.ceil(totalItems / itemsPerView);
            maxIndex = Math.max(0, totalSlides - 1);
        }

        // Update carousel position
        function updateCarousel() {
            updateItemWidths();
            const gap = getTrackGap();

            if (items.length <= itemsPerView) {
                track.style.transform = 'translateX(0)';
                equalizeBrandCardHeights();
                return;
            }

            const carouselWidth = carousel.offsetWidth;
            const pageStep = carouselWidth + gap;
            const translateX = -(currentIndex * pageStep);

            track.style.transform = `translateX(${translateX}px)`;
            equalizeBrandCardHeights();
        }

        // Update progress bar
        function updateProgress() {
            if (totalSlides === 0) return;

            const progress = ((currentIndex + 1) / totalSlides) * 100;
            if (progressBar) {
                progressBar.style.width = `${progress}%`;
            }
            if (progressLine) {
                progressLine.style.width = `${progress}%`;
            }
        }

        // Navigate carousel
        function navigateCarousel(direction) {
            const newIndex = currentIndex + direction;

            if (newIndex < 0) {
                currentIndex = 0;
            } else if (newIndex > maxIndex) {
                currentIndex = maxIndex;
            } else {
                currentIndex = newIndex;
            }

            updateCarousel();
            updateProgress();
            updateButtons();
        }

        // Update button states
        function updateButtons() {
            if (prevButton) {
                prevButton.disabled = currentIndex === 0;
            }

            if (nextButton) {
                nextButton.disabled = currentIndex >= maxIndex || items.length <= itemsPerView;
            }
        }

        // Touch/swipe handlers
        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            const swipeThreshold = 50; // Minimum distance for a swipe
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // Swipe left - next slide
                    navigateCarousel(1);
                } else {
                    // Swipe right - previous slide
                    navigateCarousel(-1);
                }
            }
        }

        // Initialize this carousel
        updateItemsPerView();
        updateCarousel();
        updateProgress();
        updateButtons();
        equalizeBrandCardHeights();

        // Set up event listeners
        if (prevButton) {
            prevButton.addEventListener('click', () => navigateCarousel(-1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => navigateCarousel(1));
        }

        // Touch/swipe support
        carousel.addEventListener('touchstart', handleTouchStart, { passive: true });
        carousel.addEventListener('touchend', handleTouchEnd, { passive: true });

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                updateItemsPerView();
                updateCarousel();
                updateProgress();
                updateButtons();
                equalizeBrandCardHeights();
            }, 250);
        });

        window.addEventListener('load', () => {
            equalizeBrandCardHeights();
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            // Already initialized above, but ensure it runs after DOM is ready
        });
    }
})();
